import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_beauty_bestsellers: FaireCategoryEntity = {
  token: "cat_beauty-bestsellers",
  type: "category",
  name: "Bestsellers",
  level: 2,
  parentToken: "cat_beauty-wellness",
  href: "/category/beauty-wellness/bestsellers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
